/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import Table from "../../../components/common/new/Table/Table";
import tableStyle from "../../../theme/styles/table";
import styles from "../MemberRoleTable/style";
import Typography from "../../../components/common/new/Typography/Typography";

const tabelCellWidth = {
  tiny: { maxWidth: "3.5rem", textAlign: "center" },
  small: { maxWidth: "6rem", textAlign: "center" },
  medium: { maxWidth: "10rem", textAlign: "center" },
  large: { maxWidth: "14rem", textAlign: "center" },
};

function ManageIpConfigTable({ searchData, onToggleStatus, onUpdateIp }) {
  const [editRowId, setEditRowId] = useState(null);
  const [editIp, setEditIp] = useState("");

  const startEdit = (row) => {
    setEditRowId(row.id);
    setEditIp(row.ipAddress);
  };

  const cancelEdit = () => {
    setEditRowId(null);
    setEditIp("");
  };

  const saveEdit = () => {
    onUpdateIp(editRowId, editIp);
    cancelEdit();
  };

  const getRows = () =>
    searchData.map((row) => (
      <TableRow key={row.id} style={tableStyle.tableRow}>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {row.venueName || "-"}
          </Typography>
        </TableCell>

        <TableCell style={tabelCellWidth.medium}>
          {editRowId === row.id ? (
            <input
              type="text"
              value={editIp}
              onChange={(e) => setEditIp(e.target.value)}
              style={{ padding: "4px", width: "100%" }}
            />
          ) : (
            <Typography style={styles.typoghrphyStyle}>
              {row.ipAddress || "-"}
            </Typography>
          )}
        </TableCell>

        <TableCell style={tabelCellWidth.small}>
          <button
            type="button"
            onClick={() => onToggleStatus(row.id, row.active)}
            style={{
              padding: "4px 8px",
              borderRadius: "12px",
              backgroundColor: row.active ? "#D4EDDA" : "#F8D7DA",
              color: row.active ? "#155724" : "#721C24",
              fontWeight: "bold",
              fontSize: "0.8rem",
              minWidth: "60px",
              textAlign: "center",
              cursor: "pointer",
              border: "none",
            }}
          >
            {row.active ? "Active" : "Inactive"}
          </button>
        </TableCell>

        <TableCell style={tabelCellWidth.small}>
          {editRowId === row.id ? (
            <>
              <button
                type="button"
                onClick={saveEdit}
                style={{
                  backgroundColor: "#388f38ff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  marginRight: "4px",
                }}
              >
                Save
              </button>
              <button
                type="button"
                onClick={cancelEdit}
                style={{
                  backgroundColor: "#FF0000",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "8px 16px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </>
          ) : (
            <button
              type="button"
              onClick={() => startEdit(row)}
              style={{
                backgroundColor: "#043D90",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "8px 16px",
                cursor: "pointer",
              }}
            >
              Edit
            </button>
          )}
        </TableCell>
      </TableRow>
    ));

  const columns = [
    { key: "venueName", displayName: "Venue Name" },
    { key: "ipAddress", displayName: "IP Address" },
    { key: "status", displayName: "Status" },
    { key: "actions", displayName: "Actions" },
  ];

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={columns}
        rows={getRows()}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "center",
        }}
      />
    </div>
  );
}

export default ManageIpConfigTable;
